import { ONFIDO_KEYS } from "../constants";
import { TOnfidoParams } from "../types";
import { StepDefinition } from "onfido-sdk-ui/types/shared/Types";

type TGetOnfidoConfigurations = (
  params: TOnfidoParams,
  token: string,
) => {
  steps: StepDefinition[];
  token: string;
}[];

type DocsOptions = Partial<
  Record<
    | "passport"
    | "driving_licence"
    | "national_identity_card"
    | "residence_permit",
    string
  >
>;

function normalizeAvailableDocuments(availableChoices: string[]): DocsOptions {
  return availableChoices.reduce(
    (acc, documentType) => ({
      ...acc,
      [documentType.toLocaleLowerCase()]: { country: "ITA" },
    }),
    {},
  );
}

function normalizeDocumentOptions(availableChoices?: string[]):
  | {
      options: StepDefinition["options"];
    }
  | undefined {
  if (!(availableChoices || []).length) {
    return undefined;
  }
  return {
    options: {
      forceCrossDevice: true,
      documentTypes: normalizeAvailableDocuments(availableChoices || []),
    },
  };
}

export const getOnfidoPhases: TGetOnfidoConfigurations = (
  { recognitions },
  token: string,
) => {
  const firstPhaseSteps: StepDefinition[] = [];
  const secondPhaseSteps: StepDefinition[] = [];
  const phases: ReturnType<TGetOnfidoConfigurations> = [];
  recognitions.forEach(recognition => {
    const motionParams =
      recognition.mode === "motion" ? { recordMotionAudio: true } : {};
    if (recognition.key === ONFIDO_KEYS.VIDEO_CAPTCHA) {
      firstPhaseSteps.push({
        type: ONFIDO_KEYS.FACE,
        options: {
          requestedVariant: recognition.mode,
          photoCaptureFallback: false,
          forceCrossDevice: (recognition?.forceCrossDevice || false) as never,
          ...motionParams,
        },
      });
    }
    if (recognition.key === ONFIDO_KEYS.OCR_DOCUMENTO) {
      firstPhaseSteps.push({
        type: ONFIDO_KEYS.DOCUMENT,
        ...(normalizeDocumentOptions(recognition?.availableChoices) || {}),
      });
    }
    if (recognition.key === ONFIDO_KEYS.OCR_DOCUMENTO_2) {
      secondPhaseSteps.push({
        type: ONFIDO_KEYS.DOCUMENT,
        ...(normalizeDocumentOptions(recognition?.availableChoices) || {}),
      });
    }
  });
  if (firstPhaseSteps.length > 0) {
    phases.push({ steps: firstPhaseSteps, token });
  }
  if (secondPhaseSteps.length > 0) {
    phases.push({ steps: secondPhaseSteps, token });
  }
  return phases;
};
